module.exports = __webpack_public_path__ + "img/search-repeat.b4b862ba.png";